import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
// import {
//   getCommonTextFilterParams,
//   getSetFilterParams,
//   getSetDatefilterParams,
// } from "../../utils/agGridFilters";
// import DeleteConfirmationModal from "../../shared/modal/deleteConfirmation";
// import { DateTimeFormatter } from "../../shared/controls/formatters";
import {
  getCommonTextFilterParams,
  getSetDatefilterParams,
  getSetFilterParams,
} from '../../../utils/agGridFilters';
import DeleteConfirmationModal from '../../../shared/modal/deleteConfirmation';
import { DateFormatter, DateTimeFormatter } from '../../../shared/controls/formatters';
import { getUserRole } from '../../../redux/selector';
import { useSelector } from 'react-redux';

const OptionButton = ({
  handleClickOpenEditForm,
  paramsValue,
  handleOpenViewForm,
  rowData,
  handleClickDelete,
}) => {
  const userRole = useSelector(getUserRole)
    const role = userRole || '';
    const isSystemManager = role === 'System Manager';
  const [showConfirmation, setShowConfirmation] = React.useState(false);

  const handleDeleteClick = () => {
    setShowConfirmation(true);
  };

  const handleConfirmDelete = () => {
    handleClickDelete(paramsValue);
    setShowConfirmation(false);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };
  const isDisabled =
    rowData?.status && ['paid', 'void', 'cancelled'].includes(rowData.status.toLowerCase());

  return (
    <div className="action-menu">
      {isDisabled && !isSystemManager ? (
        <img
          src="/assets/images/edit.png"
          style={{ filter: 'grayscale(100%)', opacity: 0.5, cursor: 'auto' }}
          className="action-img1"
          alt="Edit"
          title="Edit"
        ></img>
      ) : (
        <img
          src="/assets/images/edit.png"
          className="action-img1"
          onClick={() => handleClickOpenEditForm(paramsValue)}
          alt="Edit"
          title="Edit"
        ></img>
      )}
      <img
        src="/assets/images/view.png"
        className="action-img2"
        onClick={() => handleOpenViewForm(paramsValue)}
        alt="View"
        title="View"
      />
{isDisabled && !isSystemManager ? (
      <img
        src="/assets/images/trash.png"
        className="action-img2"
        style={{ filter: 'grayscale(100%)', opacity: 0.5, cursor: 'auto' }}
        alt="Delete"
        title="Delete"
      ></img>
       ) : (
        <img
        src="/assets/images/trash.png"
        className="action-img2"
        onClick={handleDeleteClick}
        alt="Delete"
        title="Delete"
      ></img>
        )}
      <DeleteConfirmationModal
        show={showConfirmation}
        handleClose={handleCloseConfirmation}
        handleConfirm={handleConfirmDelete}
        rowData={rowData}
      />
    </div>
  );
};

const useInvoiceColumnDefs = ({ salesList, gridData, handleClickDelete, owner }) => {
  const navigate = useNavigate();
  const commonTextFilterParams = useMemo(() => getCommonTextFilterParams(), []);
  const dateFilterParams = useMemo(() => getSetDatefilterParams(), []);
  const filterParams = useMemo(() => getSetFilterParams, []);

  const handleClickOpenEditForm = (paramsValue) => {
    navigate(`/sales/editInvoice?id=${paramsValue.id}`, {
      state: paramsValue,
    });
  };

  const handleOpenViewForm = (paramsValue) => {
    navigate(`/sales/viewInvoice?id=${paramsValue.id}`, {
      state: paramsValue,
    });
  };

  const actionsColumn = useMemo(() => {
    return [
      {
        headerName: 'Actions',
        cellRenderer: (params) => {
          const rowData = { ...params.data, rowIndex: params.rowIndex };
          return (
            <OptionButton
              rowData={rowData}
              handleClickOpenEditForm={() => handleClickOpenEditForm(rowData)}
              handleClickDelete={() => handleClickDelete(rowData)}
              handleOpenViewForm={() => handleOpenViewForm(rowData)}
            />
          );
        },
        maxWidth: 100,
        minWidth: 100,
        sortable: false,
        filter: false,
        pinned: 'left',
      },
    ];
  }, [handleClickOpenEditForm, handleClickDelete]);

  const columnDefs = useMemo(() => {
    return [
      ...actionsColumn,
      {
        headerName: 'Code',
        field: 'code',
        width: 150,
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Subject',
        field: 'subject',
        width: 150,
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Status',
        field: 'status',
        width: 120,
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },

      {
        headerName: 'Invoice Date',
        field: 'invoiceDate',
        valueFormatter: DateFormatter,
        filter: 'agDateColumnFilter',
        filterParams: dateFilterParams,
      },
      {
        headerName: 'Grand Total',
        field: 'grandTotal',
        filter: 'agNumberColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Contact Name',
        field: 'contactName',
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Account Name',
        field: 'accountName',
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Invoice Owner',
        field: 'invoiceOwner',
        filter: 'agSetColumnFilter',
        filterParams: filterParams(owner?.map((item) => item.display_name)),
      },
    ];
  }, [actionsColumn, commonTextFilterParams, filterParams, salesList, gridData, dateFilterParams, owner]);

  return columnDefs;
};

export default useInvoiceColumnDefs;
